const SPACEBAR = 32;
const ENTER = 13;

export const isSpaceBar = ev => ev.keyCode === SPACEBAR;
export const isEnter = ev => ev.keyCode === ENTER;
export const isEnterOrSpace = ev => isEnter(ev) || isSpaceBar(ev);

export const onSpaceBar =
  (call = () => null) =>
    ev =>
      isSpaceBar(ev) && call(ev);

export const onEnter =
  (call = () => null) =>
    ev =>
      isEnter(ev) && call(ev);

export const onEnterOrSpace =
  (call = () => null) =>
    ev =>
      isEnterOrSpace(ev) && call(ev);

export default {
  isSpaceBar,
  onSpaceBar,
  isEnter,
  onEnter,
  isEnterOrSpace,
  onEnterOrSpace,
};
